package com.schoolconnect.app.repository.parentattendance

import com.schoolconnect.app.datasource.network.KtorApiClient
import kotlinx.serialization.json.JsonObject

object ParentAttendanceRepository {
    suspend fun loadDetail(studentId: String, absenceLimit: Int = 50): Result<JsonObject> =
        KtorApiClient.getParentAttendanceDetail(studentId.trim(), absenceLimit.coerceIn(1, 200))

    suspend fun loadCalendar(studentId: String, year: Int, month: Int): Result<JsonObject> =
        KtorApiClient.getParentAttendanceCalendar(studentId.trim(), year, month)
}
